import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdvertisingLanding from './components/AdvertisingLanding';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/advertise" element={<AdvertisingLanding />} />
      </Routes>
    </Router>
  );
};

export default App;